module.exports = __webpack_public_path__ + "img/icon_i.1ec91d68.svg";